<template>
  <PageSection>
    <div
      :class="$style.container"
      class="container-fluid"
    >
      <JoinHeading
        :level="2"
        class="text-center mb-7"
      >
        {{ $t('join.section.benefits.title') }}
      </JoinHeading>

      <div class="mt-3 d-flex flex-column align-items-center">
        <PageTwoColumnsContent
          v-for="(item, index) in items"
          :key="item.image"
          :class="$style.item"
          :image="item.image"
          :content="item.content"
          :image-class="item.imageClass"
          :content-class="item.contentClass"
          :image-pull-right="index % 2 === 1"
        />
      </div>
    </div>
  </PageSection>
</template>

<script lang="ts">
import PageSection from '@/scripts/pages/onepager/components/PageSection.ts.vue';
import PageContainer from '@/scripts/pages/onepager/components/PageContainer.ts.vue';
import PageTwoColumnsContent, { PageTwoColumnsContentProps } from '@/scripts/pages/onepager/components/PageTwoColumnsContent.ts.vue';
import { JoinBaseComponent } from '../common/JoinBaseComponent';
import JoinHeading from '../common/JoinHeading.ts.vue';
import JoinHeadingStyleModule from '../common/JoinHeading.module.scss';
import JoinTitleParagraphStyleModule from '../common/JoinTitleParagraph.module.scss';
import { BenefitsGraphics } from '../assets/media';
import { LocaleItem } from '../types/LocaleItem';

const itemGraphics = [
  BenefitsGraphics.viralEngine,
  BenefitsGraphics.dish,
  BenefitsGraphics.distributionChance,
  BenefitsGraphics.community,
  BenefitsGraphics.monetisation,
];

export default JoinBaseComponent.extend({
  components: {
    PageTwoColumnsContent,
    PageSection,
    PageContainer,
    JoinHeading,
  },
  data() {
    const items: PageTwoColumnsContentProps[] = (this.$t('join.section.benefits.items') as LocaleItem[])
      .map((item, index) => ({
        image: itemGraphics[index],
        content: {
          title: item.title,
          paragraphs: item.paragraphs,
          titleClass: [JoinHeadingStyleModule.heading4, JoinHeadingStyleModule.heading],
          paragraphClass: JoinTitleParagraphStyleModule.paragraph,
        },
        imageClass: this.$style.itemImage,
        contentClass: this.$style.itemContent,
      }))
    ;

    return {
      items,
    };
  },
});
</script>

<style module lang="scss">
@import '~@/scripts/pages/onepager/styles/variables-entry';
@import '~@/scripts/pages/onepager/styles/variables';

.container {
  max-width: 320px;
  @include media-breakpoint-up(md) {
    max-width: map-get($container-max-widths, xl);
  }
}
.item {
  gap: 2rem;
  margin-bottom: 5rem;
}
@include media-breakpoint-up(md) {
  .itemImage {
    width: 42% !important;
  }
  .itemContent {
    width: 54% !important;
  }
}
</style>
